import { useEffect, useRef, useState } from 'react';
import CategoryBack from '../../assets/images/CategoryBack.svg';
import Star from '../../assets/images/Star.png';
import SmartRating from '../../assets/images/smart-rating.avif';
import { useNavigate, PrefetchPageLinks } from 'react-router';
import { ROUTES, eventCategories, SELECTED_CATEGORY_ID_KEY } from '@/constants';

const CATEGORY_ICONS = Object.fromEntries(eventCategories.map((c) => [c.id, c.icon]));

export default function SmartRatingCelebratory({ open, onClose, categoryId }) {
	const cardRef = useRef(null);
	const [visible, setVisible] = useState(false);
	const category = eventCategories.find((c) => c.id === categoryId);
	const categoryName = category?.name || 'Unknown';
	const icon = CATEGORY_ICONS[categoryId];
	const backgroundImage = CategoryBack;
	const smartRating = SmartRating;

	const [progress, setProgress] = useState(96);
	const [count, setCount] = useState(24);
	const [showFinal, setShowFinal] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		if (open) {
			setVisible(true);
		}
	}, [open]);

	useEffect(() => {
		if (!visible) return;

		const start = 96;
		const end = 100;
		let startTime = null;

		const animate = (ts) => {
			if (!startTime) startTime = ts;

			const t = Math.min((ts - startTime) / 700, 1);

			const value = start + (end - start) * t;
			setProgress(value);

			if (t < 1) {
				requestAnimationFrame(animate);
			} else {
				if (t < 1) {
					requestAnimationFrame(animate);
				} else {
					setTimeout(() => {
						setCount(25);

						setTimeout(() => {
							setShowFinal(true);
						}, 1000);
					}, 700);
				}
			}
		};

		requestAnimationFrame(animate);
	}, [visible]);

	const closeNow = (reason) => {
		setVisible(false);
		setTimeout(() => onClose?.(reason || 'close'), 150);
	};
	if (!open) return null;

	return (
		<>
			<PrefetchPageLinks page={ROUTES.PROFILE} />
			<div className="fixed inset-0 z-[9999] bg-[#1E2748]">
				<div ref={cardRef} className="relative w-full h-full">
					{/* Glow + Main rectangle */}

					{!showFinal ? (
						<>
							<div
								className="absolute top-[238px] left-1/2 -translate-x-1/2 w-[329px] h-[74px] rounded-lg"
								style={{
									filter: 'blur(40px)',
									background:
										'radial-gradient(50% 50% at 50% 50%, rgba(38,103,255,0.85) 0%, rgba(23,62,153,0) 100%)',
								}}
							></div>

							<div
								className="absolute top-[238px] left-1/2 -translate-x-1/2 w-[329px] h-[74px] flex items-center justify-center bg-[#2D3A6C] rounded-lg border border-[#1E2748] shadow-2xl p-4"
								style={{ boxShadow: '0px 0px 64px 0px #2667FF', opacity: 0.85 }}
							>
								<div className="flex flex-col text-white w-full gap-2">
									<div className=" flex items-center justify-between w-[305px] h-[16px] font-dmsans font-bold text-[14px] leading-[100%] text-[#F7F7F8] ">
										<span>Trades Completed</span>{' '}
										<span style={{ textAlign: 'right' }}>{count}/25</span>
									</div>
									<div
										className="flex items-center justify-between"
										style={{
											width: '305px',
											height: '10px',
											fontWeight: 300,
											fontSize: '10px',
											lineHeight: '14px',
											letterSpacing: '0%',
											opacity: 1,
											color: '#9FA8C6',
										}}
									>
										<span>Placement in Progress</span>
									</div>
									<div
										style={{
											width: '305px',
											height: '4px',
											borderRadius: '99px',
											background: 'var(--Brand-Blue-300, #81A1F8)',
											position: 'relative',
											overflow: 'hidden',
										}}
									>
										<div
											style={{
												height: '100%',
												width: `${progress}%`,
												background: '#2667FF',
												borderRadius: '99px',
											}}
										></div>
									</div>
									<div
										className="absolute"
										style={{
											top: '-12px',
											left: '300px',
											transform: 'rotate(-25deg)',
										}}
									>
										<img
											src={Star}
											alt=""
											className="relative"
											style={{ width: '20px', height: '24px', zIndex: 3 }}
										/>
									</div>
									<div
										className="absolute"
										style={{
											fontSize: '12px',
											top: '-12px',
											left: '331px',
											color: 'var(--Gray-100, #F7F7F8)',
											textShadow: '0 0 8px #2667FF',
										}}
									>
										✦
									</div>
									<div
										className="absolute"
										style={{
											fontSize: '6px',
											top: '-16px',
											left: '325px',
											color: 'var(--Gray-100, #F7F7F8)',
											textShadow: '0 0 8px #2667FF',
										}}
									>
										✦
									</div>

									<div
										className="absolute"
										style={{
											top: '60px',
											left: '10px',
										}}
									>
										<img src={Star} alt="" className="relative" style={{ zIndex: 3 }} />
									</div>

									<div
										className="absolute"
										style={{
											fontSize: '12px',
											top: '70px',
											left: '-10px',
											color: 'var(--Gray-100, #F7F7F8)',
											textShadow: '0 0 8px #2667FF',
										}}
									>
										✧
									</div>
									<div
										className="absolute"
										style={{
											fontSize: '6px',
											top: '80px',
											left: '0px',
											color: 'var(--Gray-100, #F7F7F8)',
											textShadow: '0 0 8px #2667FF',
										}}
									>
										✦
									</div>
								</div>
							</div>

							{/* Title + Subtext */}
							<div className="absolute top-[360px] left-1/2 -translate-x-1/2 flex flex-col items-center gap-4">
								<span className="font-dmsans font-semibold text-[20px] leading-[24px] text-[#F7F7F8] text-center">
									Your SMART Rating is here
								</span>
								<p className="font-dmsans font-normal text-[14px] leading-[20px] text-[#D4D5D8] text-center mb-4 w-[361px]">
									You’ve completed your placement phase <br /> and entered the ranked tier.
								</p>
								<span className="font-dmsans font-bold text-[14px] leading-[20px] text-[#81A1F8] text-center">
									Let the competition begin!
								</span>
							</div>
						</>
					) : (
						<>
							<div
								className="absolute top-[142px] left-1/2 -translate-x-1/2 flex flex-col items-center justify-start"
								style={{ width: '160px', height: '160px' }}
							>
								<div
									className="relative flex flex-col items-center justify-center"
									style={{ width: '160px', height: '160px' }}
								>
									<div
										className="absolute rounded-full"
										style={{
											width: '160px',
											height: '160px',

											border: '0.5px solid var(--Brand-Blue-500)',
											backdropFilter: 'blur(6px)',
											backgroundColor: 'rgba(23, 62, 153, 0.05)',
											opacity: 0.5,
											zIndex: 1,
										}}
									></div>

									<div
										className="absolute rounded-full"
										style={{
											width: '160px',
											height: '160px',
											background:
												'radial-gradient(50% 50% at 50% 50%, rgba(38,103,255,0.85) 0%, rgba(23,62,153,0) 100%)',
											filter: 'blur(6px)',
											opacity: 0.65,
											border: '0.5px solid var(--Brand-Blue-300, #81A1F8)',
											zIndex: 1,
										}}
									></div>

									<div
										className="relative flex items-center justify-center"
										style={{ width: '60px', height: '60px', zIndex: 2 }}
									>
										<img
											src={backgroundImage}
											alt=""
											className="absolute"
											style={{ width: '60px', height: '60px', zIndex: 2 }}
										/>
										<img
											src={icon}
											alt=""
											className="relative"
											style={{ width: '24px', height: '24px', zIndex: 3 }}
										/>
									</div>
								</div>
							</div>
							<div className="absolute top-[269px] left-1/2 -translate-x-1/2 flex flex-col items-center justify-center gap-4">
								<img
									src={smartRating}
									alt=""
									style={{ width: '115px', height: '32px', zIndex: 4 }}
								/>
							</div>
							<div className="absolute top-[352px] left-1/2 -translate-x-1/2 flex flex-col items-center justify-center gap-4">
								<h2 className="text-[#F7F7F8] text-[20px] sm:text-[20px] font-[400] font-sans leading-[24px] tracking-[-0.5%] text-center">
									You‘re finally qualified <br />
									for ranked competition <br />
									in {categoryName}.
								</h2>
								<p className="font-dmsans font-normal text-[14px] leading-[20px] text-[#D4D5D8] text-center mb-4 w-[361px]">
									Check your profile to learn more <br />
									about your SMART Rating.
								</p>
							</div>
						</>
					)}
					{/* Buttons */}
					<div className="absolute top-[626px] left-1/2 -translate-x-1/2 flex flex-col gap-3 items-center">
						<button
							className="w-[180px] h-[40px] rounded-[30px] bg-[#2667FF] text-[#F7F7F8] font-bold"
							onClick={() => {
								localStorage.setItem(SELECTED_CATEGORY_ID_KEY, categoryId);
								closeNow('profile');
								navigate(`${ROUTES.PROFILE}`);
							}}
						>
							View My Profile
						</button>
						<button
							onClick={() => closeNow('backdrop')}
							className="w-[180px] h-[40px] rounded-[30px] bg-[#1E2748] text-[#F7F7F8] font-bold"
						>
							Close
						</button>
					</div>
				</div>
			</div>
		</>
	);
}
